import { defineStore } from 'pinia'
import {onMounted, onUnmounted, ref} from 'vue'

export const useWindowSizeStore = defineStore('WindowSize', () => {
  const width = ref(window.innerWidth)
  const height = ref(window.innerHeight)

  function handleResizeWindow() {
    width.value = window.innerWidth
    height.value = window.innerHeight
  }

  onMounted(() => {
    window.addEventListener('resize', handleResizeWindow)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResizeWindow)
  })

  return {
    width,
    height
  }
})
